import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { RepeatMonthlyStrategy } from '../../../manageMentorship/types/repeatMonthlyStrategy';
import { WeekdayPosition } from '../../../manageMentorship/types/weekdayPosition';
import { useGetWeekdayPositionInMonth } from '../hooks/useGetWeekdayPositionInMonth';
import { DateHelper } from 'src/shared/helpers/date';
export function useMonthlyStrategyItems() {
    const { t } = useTranslation();
    const { watch } = useFormContext();
    const date = watch('date');
    const day = date.getDate();
    const weekday = DateHelper.formatIsoString(date.toISOString(), { weekday: 'long' });
    const { position, isTheLastDay } = useGetWeekdayPositionInMonth(date);
    const monthlyStrategyItems = useMemo(() => {
        const items = [
            {
                label: t('mentorship.form.recurring_session.frequency.options.custom.on_the_day', {
                    date: day
                }),
                value: RepeatMonthlyStrategy.OnDay
            }
        ];
        if (position.key !== WeekdayPosition.Fifth) {
            items.push({
                label: `${t('mentorship.form.recurring_session.frequency.options.custom.on')} ${position.text} ${weekday}`,
                value: position.key
            });
        }
        if (isTheLastDay) {
            items.push({
                label: `${t('mentorship.form.recurring_session.frequency.options.custom.on')} ${t('mentorship.day_position_in_month.last')} ${weekday}`,
                value: RepeatMonthlyStrategy.OnLastWeekday
            });
        }
        return items;
    }, [t, day, weekday, position.key, position.text, isTheLastDay]);
    return monthlyStrategyItems;
}
